import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Question } from 'app/shared/models/question';
import { SingleChoiceQuestion } from 'app/shared/models/single-choice-question';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'dac-question-single-checkbox',
  templateUrl: './question-single-checkbox.component.html'
})
export class QuestionSingleCheckboxComponent implements OnInit {
 
  @Input() question:Question;
  @Output() answered:EventEmitter<Question>;
  constructor() { 
    this.answered = new EventEmitter<Question>();
  }

  ngOnInit() {
  }

  isChecked() {
    if (!this.question) {
      return false;
    }
    let answer = this.question.answerForSave;
    return answer.isSelected;
  }
  toggleAnswer(event:Event) {
    event.stopPropagation();
    event.preventDefault();
    let answer = this.question.answerForSave;
    let isSelected = !answer.isSelected;
    this.question.setSavedAnswer({isSelected: isSelected}, null);
    this.answered.emit(this.question);
  }
}



// WEBPACK FOOTER //
// ./src/app/assessments/question-single-checkbox/question-single-checkbox.component.ts